// 环境变量
/*
    1.一般来说项目服务器分为但不限于
    *开始时 JAVA让我调的接口在JAVA开发自己电脑上 JAVA自己电脑搭建的服务器
    *测试工程师自己搭建的服务器 测试服务器
    *内测（灰度）服务器 
    *生产服务器 （线上）
*/ 

// let developmentUrl = "http://localhost:8087/";                   //本地电脑开发环境,开发工具运行
// let developmentUrl = "http://192.168.1.104:8087/";               //本地电脑开发环境,远程终端访问
let developmentUrl = "/prod-api/";                                  //服务器正式发布模式，使用相对路径的模式

let urlDev = {
    businessUrl :`${developmentUrl}`,
    uploadUrl:`${developmentUrl}上传的后缀地址`
}
let {businessUrl ,uploadUrl} = urlDev;
export {
    businessUrl,
    uploadUrl,
    developmentUrl
}


// WEBPACK FOOTER //
// ./src/config/env.js